/**
 * Shared application configuration
 *
 * Central place for environment-based configuration values
 * used across the application.
 */

/**
 * Base URL for the application
 * Used for generating absolute URLs in emails, redirects, etc.
 */
export const BASE_URL = process.env.NEXT_PUBLIC_APP_URL || "https://oekopunktemarkt.de";

/**
 * Admin panel URL
 */
export const ADMIN_URL = process.env.ADMIN_URL || "https://oekopunktemarkt.de/admin";

// NOTE: honeypot "canary" accounts are marked by the `users.is_canary` flag
// (see the shared `is_canary_owner` predicate + isCanaryOwner in
// entity-ownership.ts), NOT by a config value. The CANARY_USER_IDS env var is
// consumed only by the honeypot sync tooling that writes that flag; the app
// never reads it directly, so no config export is needed here.

/**
 * Resend cooldown for the email-OTP flow on /verify. The send response
 * also supplies the server minimum so an environment override cannot
 * enable a resend earlier than the server permits.
 */
export const OTP_RESEND_COOLDOWN_SECONDS =
  Number(process.env.NEXT_PUBLIC_OTP_RESEND_COOLDOWN_SECONDS) || 60;
